<template>
    <div class="columns is-centered mt-6 mb-3">
        <div class="column is-10 box is-block is-radiusless has-text-centered">
            <OperatorsKpi :signalRSocket="signalRSocket" />
            <UsersKpi :signalRSocket="signalRSocket" />
        </div>
    </div>
</template>

<script>
import OperatorsKpi from "./OperatorsKpi.vue";
import UsersKpi from "./UsersKpi.vue";

export default {
    name: "supervisor-dashboard",
    components: {
        OperatorsKpi,
        UsersKpi,
    },
    props: {
        signalRSocket: {
            type: Object,
            required: true,
        },
    },
};
</script>